(function () {
  function initialize(root) {
    if (!root || root.dataset.carouselReady) return;
    root.dataset.carouselReady = 'true';
    var track = root.querySelector('[data-carousel-track]');
    var slides = Array.prototype.slice.call(track.children);
    var current = root.querySelector('[data-carousel-current]');
    var progress = root.querySelector('[data-carousel-progress]');
    function step() {
      if (!slides.length) return track.clientWidth;
      return slides[0].getBoundingClientRect().width + 16;
    }
    function update() {
      var index = Math.round(track.scrollLeft / step());
      current.textContent = Math.min(slides.length, index + 1);
      progress.style.width = Math.max(8, ((index + 1) / slides.length) * 100) + '%';
    }
    root.querySelector('[data-carousel-previous]').addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    root.querySelector('[data-carousel-next]').addEventListener('click', function () {
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
      track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + step(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    update();
  }
  function initializeAll(scope) { (scope || document).querySelectorAll('[data-sms-featured-carousel]').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  else initializeAll(document);
  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
}());
